import * as Yup from 'yup';

import {
  CreateBrokerField,
  getBrokerFieldRequiredErrorMessage,
  getBrokerFieldWrongTypeErrorMessage,
} from '@converge/data';

export const stringRequired = (fieldName: CreateBrokerField) => {
  return Yup.string()
    .typeError(getBrokerFieldWrongTypeErrorMessage(fieldName))
    .required(getBrokerFieldRequiredErrorMessage())
    .trim()
    .min(1, getBrokerFieldWrongTypeErrorMessage(fieldName));
};

export const emailRequired = (fieldName: CreateBrokerField) => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return Yup.string()
    .matches(emailRegex, 'Please enter a valid email address')
    .typeError(getBrokerFieldWrongTypeErrorMessage(fieldName))
    .required(getBrokerFieldRequiredErrorMessage())
    .trim()
    .min(1, getBrokerFieldWrongTypeErrorMessage(fieldName));
};
export const CreateBrokerFieldsSchema = Yup.object({
  [CreateBrokerField.FirstName]: stringRequired(CreateBrokerField.FirstName),
  [CreateBrokerField.LastName]: stringRequired(CreateBrokerField.LastName),

  [CreateBrokerField.Npn]: Yup.string().optional(),

  [CreateBrokerField.GlobalParent]: stringRequired(
    CreateBrokerField.GlobalParent
  ),
  [CreateBrokerField.Office]: Yup.string().optional().nullable(),
  [CreateBrokerField.BrokerTeam]: Yup.string().optional().nullable(),
  [CreateBrokerField.Email]: emailRequired(CreateBrokerField.Email),
  [CreateBrokerField.OfficePhoneNumber]: Yup.string().optional().nullable(),
  [CreateBrokerField.MobilePhoneNumber]: Yup.string().optional().nullable(),
  [CreateBrokerField.BusinessDevelopmentManager]: Yup.string()
    .optional()
    .nullable(),
  [CreateBrokerField.Underwriter]: Yup.string().optional().nullable(),
  [CreateBrokerField.UwRegion]: Yup.string().optional().nullable(),
});
